import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=5c90fd9e"
import script from "./hospital.vue?vue&type=script&lang=ts"
export * from "./hospital.vue?vue&type=script&lang=ts"
import style0 from "./hospital.vue?vue&type=style&index=0&id=5c90fd9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports